import React from 'react'
import {graphql, Link, navigate} from 'gatsby'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import PostCard from 'src/components/molecules/PostCard'
import PostsSearch from 'src/components/molecules/PostsSearch'
import Results from 'src/components/templates/ResultsPage'

import {ArticleDocument} from '../../../types.generated'
import type {LocalSearchPosts} from 'src/types/pageData'

interface Props {
  data: {
    allPrismicArticle: {
      edges: Array<{
        node: ArticleDocument
      }>
    }
    localSearchPosts: LocalSearchPosts
  }
}

const SearchResultsPage = ({data}: Props) => {
  const {store} = data.localSearchPosts
  const allPosts = data.allPrismicArticle.edges

  return (
    <Results
      postType="Market Insights"
      heroContent={() => (
        <Container sx={{mt: {lg: 15, xs: 20}}}>
          <Typography sx={{mb: 10}}>
            Back to <Link to="/insights">Insights</Link>
          </Typography>
          <Typography variant="h3" component="h1" gutterBottom>
            Market Insights
          </Typography>
        </Container>
      )}
      postsListContent={() => (
        <>
          <Grid container sx={{mb: 2}}>
            <Grid item xs={12} md={6}>
              <PostsSearch
                store={store}
                onSubmit={(search: string) =>
                  navigate('/insights/search', {state: {search}})
                }
              ></PostsSearch>
            </Grid>
          </Grid>
          <Grid item container spacing={2}>
            {allPosts.map(post => (
              <Grid item xs={12} md={4} key={post.node.uid}>
                <PostCard
                  excerpt={`${post.node.data.post_body.text.slice(0, 200)}...`}
                  slug={post.node.url || ''}
                  title={post.node.data.title.text}
                  date={post.node.data.date}
                  image={post.node.data.post_image?.url}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    />
  )
}

export const query = graphql`
  query ($limit: Int, $skip: Int) {
    localSearchPosts {
      index
      store
    }
    allPrismicArticle(
      filter: {tags: {eq: "market-insights"}}
      sort: {order: DESC, fields: data___date}
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          data {
            post_image {
              url
            }
            post_body {
              text
            }
            title {
              text
            }
            date
          }
          tags
          uid
          url
        }
      }
      pageInfo {
        currentPage
        pageCount
      }
    }
  }
`

export default SearchResultsPage
